import { motion } from "framer-motion";

export const SectionHeader = ({ eyebrow, title, description, actions }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
    className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6 md:mb-8"
  >
    <div className="max-w-3xl">
      <div className="eyebrow mb-2">{eyebrow}</div>
      <h2 className="font-display text-2xl md:text-[28px] leading-tight">{title}</h2>
      {description && <p className="text-sm md:text-base text-muted-foreground mt-2 leading-relaxed">{description}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
  </motion.div>
);

export const Panel = ({ title, subtitle, children, className = "", testId, right, index = 0 }) => (
  <motion.section
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay: index * 0.05 }}
    data-testid={testId}
    className={`card-surface card-hover p-4 md:p-5 ${className}`}
  >
    {(title || right) && (
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          {title && <h3 className="text-sm font-semibold tracking-tight">{title}</h3>}
          {subtitle && <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{subtitle}</p>}
        </div>
        {right}
      </div>
    )}
    {children}
  </motion.section>
);

export const Callout = ({ tone = "gold", title, children, testId }) => {
  const tones = {
    gold: "border-[rgba(201,169,97,0.3)] bg-[rgba(201,169,97,0.08)]",
    info: "border-[rgba(90,167,224,0.25)] bg-[rgba(90,167,224,0.10)]",
    warn: "border-[rgba(224,184,74,0.25)] bg-[rgba(224,184,74,0.10)]",
    danger: "border-[rgba(224,90,79,0.25)] bg-[rgba(224,90,79,0.10)]",
    success: "border-[rgba(47,191,143,0.25)] bg-[rgba(47,191,143,0.10)]",
  };
  return (
    <div data-testid={testId} className={`rounded-lg border px-4 py-3 ${tones[tone]}`}>
      {title && <div className="text-xs font-semibold uppercase tracking-[0.12em] mb-1">{title}</div>}
      <div className="text-sm leading-relaxed text-foreground/90">{children}</div>
    </div>
  );
};
